import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';

const KpiCard = ({ title, value, icon: Icon, color = '#00B4D8', subtitle }) => {
  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm text-[#6C757D] mb-1">{title}</p>
            <p className="text-3xl font-bold" style={{ color }}>
              {value !== null && value !== undefined ? value : '-'}
            </p>
            {subtitle && (
              <p className="text-xs text-[#6C757D] mt-1">{subtitle}</p>
            )}
          </div>
          {Icon && (
            <div 
              className="p-3 rounded-lg" 
              style={{ backgroundColor: `${color}15` }}
            >
              <Icon className="h-6 w-6" style={{ color }} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
